import { useRouter } from '@/hooks';
import { useEffect } from 'react';
import { getAndClearRedirectUrl } from '@/utils/auth';

export const TempAuth0Redirect = () => {
  const router = useRouter();

  useEffect(() => {
    try {
      const savedUrl = getAndClearRedirectUrl();
      if (savedUrl && savedUrl !== '/api/auth/callback') {
        router.push(savedUrl);
      } else {
        router.push('/');
      }
    } catch (error) {
      router.push('/');
    }
  }, [router]);

  return <></>;
};
